import { Box, Typography, Stack, Sheet, Chip, Divider } from "@mui/joy";
import { Sparkle } from "@phosphor-icons/react";

const UPDATES = [
    {
        version: '1.3.2',
        date: '14 февраля 2026',
        title: 'Увеличен лимит',
        changes: [
            'Дневной лимит вопросов увеличен с 15 до 25 для всех пользователей',
        ],
    },
    {
        version: '1.3.1',
        date: '13 февраля 2026',
        title: 'Исправления и улучшения',
        changes: [
            'Прогресс по категориям: в разделе тестов теперь отображается количество решённых вопросов из общего числа',
            'Объяснения в модулях: расширенные объяснения теперь доступны всем пользователям, а не только администраторам',
            'Продолжение тестов: исправлена ошибка, при которой невозможно было ответить на пропущенные вопросы при возврате к тесту',
            'Визуальные улучшения: метки HIGH YIELD стали более заметными с обновлённым цветом',
            'Безопасность: улучшена защита серверной конфигурации',
        ],
    },
    {
        version: '1.3.0',
        date: '13 февраля 2026',
        title: 'Обсуждения, серии и вопрос дня',
        changes: [
            'Обсуждения под вопросами: можно оставлять комментарии, отвечать на них и ставить лайки прямо во время прохождения теста',
            'Серия занятий: на главной странице отображается текущая серия дней подряд, рекорд и прогресс по дневной цели',
            'Вопрос дня: каждый день на главной появляется один вопрос, после ответа видна статистика сообщества',
            'Жалобы на вопросы: кнопка для сообщения о неверном ответе, опечатке или устаревшей информации',
            'Страница обновлений в боковом меню',
        ],
    },
];

export default function UpdatesPage() {
    return (
        <Box sx={{ p: 3, maxWidth: 700 }}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 4 }}>
                <Sparkle size={28} color="#DA7756" />
                <Typography level="h1">Обновления</Typography>
            </Stack>

            <Stack spacing={3}>
                {UPDATES.map((update, idx) => (
                    <Sheet key={update.version} variant="outlined" sx={{ p: 3, borderRadius: 'xl' }}>
                        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1.5 }}>
                            <Chip size="sm" variant="solid" color="primary">
                                v{update.version}
                            </Chip>
                            <Typography level="body-xs" color="neutral">
                                {update.date}
                            </Typography>
                        </Stack>
                        <Typography level="title-lg" sx={{ mb: 1.5 }}>
                            {update.title}
                        </Typography>
                        <Stack component="ul" spacing={0.75} sx={{ m: 0, pl: 2.5 }}>
                            {update.changes.map((change, i) => (
                                <Typography key={i} component="li" level="body-sm">
                                    {change}
                                </Typography>
                            ))}
                        </Stack>
                    </Sheet>
                ))}
            </Stack>
        </Box>
    );
}
